function parseJsonFromRaw(raw, routeName) {
  let json = null;
  try {
    json = JSON.parse(raw);
  } catch {
    const preview = String(raw || "").slice(0, 120).toLowerCase();
    if (preview.includes("<!doctype") || preview.includes("<html")) {
      throw new Error(`API route ${routeName} ยังไม่พร้อมใช้งานใน environment นี้ (ได้ HTML กลับมา)`);
    }
    throw new Error("API response ไม่ใช่ JSON");
  }
  return json;
}

async function postApiJson(path, payload) {
  const res = await fetch(path, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  const raw = await res.text();
  const json = parseJsonFromRaw(raw, path);
  if (!res.ok) throw new Error(json?.error || "API request failed");
  return json;
}

export async function analyzeTeamByAI(summary) {
  const json = await postApiJson("/api/analyze-team", { summary });
  if (!json?.analysis) throw new Error("AI returned empty analysis");
  return json.analysis;
}

export async function askCoachByAI(question, summary, options = {}) {
  const q = String(question || "").trim();
  if (!q) throw new Error("กรุณากรอกคำถาม");
  const detailLevel = String(options?.detailLevel || "detailed").toLowerCase();

  const json = await postApiJson("/api/chat-coach", { question: q, summary, detailLevel });
  return {
    question: q,
    answer: String(json?.answer || "").trim(),
    suggestions: Array.isArray(json?.suggestions) ? json.suggestions.slice(0, 4) : [],
    diagnosis: Array.isArray(json?.diagnosis) ? json.diagnosis.slice(0, 6) : [],
    actionPlan: Array.isArray(json?.actionPlan) ? json.actionPlan.slice(0, 6) : [],
    evidence: Array.isArray(json?.evidence) ? json.evidence.slice(0, 6) : [],
    intent: String(json?.intent || "").trim(),
    intentConfidence: Number.isFinite(Number(json?.intentConfidence)) ? Number(json.intentConfidence) : null,
    intentReasons: Array.isArray(json?.intentReasons) ? json.intentReasons.slice(0, 4) : [],
    faithfulness: json?.faithfulness && typeof json.faithfulness === "object"
      ? {
          total: Number(json.faithfulness.total) || 0,
          grounded: Number(json.faithfulness.grounded) || 0,
          ungrounded: Array.isArray(json.faithfulness.ungrounded) ? json.faithfulness.ungrounded : [],
          isFaithful: Boolean(json.faithfulness.isFaithful),
          groundingRate: Number.isFinite(Number(json.faithfulness.groundingRate)) ? Number(json.faithfulness.groundingRate) : null,
        }
      : null,
    at: new Date().toLocaleString(),
  };
}

export async function reviewTacticByAI(plan, question = "") {
  const json = await postApiJson("/api/review-tactic", { plan, question });
  return {
    summary: String(json?.summary || "").trim(),
    strengths: Array.isArray(json?.strengths) ? json.strengths : [],
    risks: Array.isArray(json?.risks) ? json.risks : [],
    checks: Array.isArray(json?.checks) ? json.checks : [],
    at: new Date().toLocaleString(),
  };
}

export async function parseDraftImageByAI(imageDataUrl) {
  const payload = { imageDataUrl: String(imageDataUrl || "").trim() };
  const json = await postApiJson("/api/parse-draft-image", payload);
  return {
    rows: Array.isArray(json?.rows) ? json.rows : [],
    notes: Array.isArray(json?.notes) ? json.notes : [],
  };
}
